const uniformsDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        const {
            gumbo: {
                gamePk
            }
        } = state;

        return !state?.config?.disableDynamicUniforms && componentDataEngine.fetchAndStore('uniforms', { gamePk });
    };
};

export default uniformsDataRequestAction;
